module.exports = __webpack_public_path__ + "img/stock4.1c2d4c70.png";